import { Component, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {RouterLink} from "@angular/router";
import {LocaleService} from "../../../../locale/locale.service";
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import {HeaderComponent} from "../../../common/header/header.component";
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-ride-information-finished',
    imports: [
        ColoredBackgroundComponent,
        FooterComponent,
        RouterLink,
        FinishBoxComponent,
        HeaderComponent,
    ],
  templateUrl: './ride-information-finished.component.html',
  styleUrl: './ride-information-finished.component.css'
})
export class RideInformationFinishedComponent {
  locale = inject(LocaleService);
}
